<td *ngFor="let option of options" class="section-2b-checkboxes__cell">
    <input
        type="radio"
        [name]="groupName"
        [value]="option"
        [checked]="selectedOption === option"
        [disabled]="isOptionDisabled(option)"
        class="section-2b-checkboxes__input saq-radio-input"
        (change)="onOptionSelected(option)"
    />
</td>
